module.exports = __webpack_public_path__ + "static/media/unstakeDark.3dc5a3d0.svg";